import React, { useCallback, useEffect, useRef, useState } from "react";
import PurchasingDocumentDialog from "./PurchasingDocumentDialog";
import { usePmsTheme } from "../../../Components/PmsThemeContext";

export function usePOApprovalDecision() {
  const { languageId } = usePmsTheme();
  const es = languageId === "es";
  const [request, setRequest] = useState(null);
  const [comments, setComments] = useState("");
  const resolveRef = useRef(null);
  const settle = useCallback((value) => {
    resolveRef.current?.(value);
    resolveRef.current = null;
    setRequest(null);
  }, []);
  useEffect(() => () => resolveRef.current?.(null), []);
  const ask = (decision, code) => new Promise((resolve) => {
    resolveRef.current?.(null);
    resolveRef.current = resolve;
    setComments("");
    setRequest({ decision, code });
  });
  const returning = request?.decision === "return";
  const title = returning ? (es ? "Devolver con comentarios" : "Return with Comments") : (es ? "Rechazar pedido" : "Reject Purchase Order");
  const label = returning ? (es ? "Comentarios para corregir el pedido" : "Comments for correcting the order") : (es ? "Motivo del rechazo" : "Rejection reason");
  return {
    ask,
    isOpen: Boolean(request),
    dialog: <PurchasingDocumentDialog isOpen={Boolean(request)} title={title}
      confirmLabel={title} onClose={() => settle(null)} onConfirm={() => comments.trim() && settle(comments.trim())}
      confirmDisabled={!comments.trim()} tone="warning"
      message={<>
        <p>{request?.code}</p>
        <label style={{ display: "grid", gap: 8 }}>{label}
          <textarea className="form-control" rows={4} required maxLength={4000} value={comments}
            onChange={(event) => setComments(event.target.value)} />
        </label>
        <p>{returning
          ? (es ? "El responsable podrá corregir y reenviar este mismo pedido. Se conservará el historial." : "The responsible user can correct and resubmit this same order. Its history will be preserved.")
          : (es ? "El rechazo es definitivo. El motivo quedará registrado." : "Rejection is final. The reason will be recorded.")}</p>
      </>} />,
  };
}
